import { FormValidators } from 'utils/form/types';
import { isEmail, isRequired } from 'utils/form/validators';
import EmailBaseFormStore from 'stores/common/EmailBaseFormStore';
import { EMAIL_SEND_BLOG_SUBSCRIBE_FORM } from 'config/email/endpoints';

export interface BlogSubscribeForm {
  email: string;
}

class BlogSubscribeFormStore extends EmailBaseFormStore<BlogSubscribeForm> {
  protected get endpoint(): string {
    return EMAIL_SEND_BLOG_SUBSCRIBE_FORM;
  }

  protected getInitialForm(): BlogSubscribeForm {
    return {
      email: '',
    };
  }

  protected get validators(): FormValidators<BlogSubscribeForm> {
    return {
      email: [isRequired(), isEmail()],
    };
  }
}

export default BlogSubscribeFormStore;
